import React, { useContext } from 'react';
import { gql, useSubscription } from '@apollo/client'

import EventContext from '../contexts/event';

const PRESENTATION_STATUSES = gql`
  subscription {
    presentation_active {
      id
      non_live_questions_active
      non_live_results_active
    }
  }
`

const LivePresentationsSubscription = () => {
  const eventContext = useContext(EventContext);

  //  console.log("eventContext",eventContext)
   console.log("PRESENTATION_STATUSES",PRESENTATION_STATUSES)

  useSubscription(PRESENTATION_STATUSES, {

    onSubscriptionData: ({ subscriptionData: { data: { presentation_active }} }) => {

       console.log("presentation_active",presentation_active)

      eventContext.setPresentationData({
        presentationsWithQuestions: presentation_active
          .filter((p: any) => p.non_live_questions_active)
          .map((p: any) => p.id),
        presentationsWithResults: presentation_active
          .filter((p: any) => p.non_live_results_active)
          .map((p: any) => p.id)
      })
    }
  })

  return <></>
}

export default LivePresentationsSubscription;
